__turbopack_context__.v({
  "country": "RegionShapeMap-module__-myYZW__country",
  "lake": "RegionShapeMap-module__-myYZW__lake",
  "map": "RegionShapeMap-module__-myYZW__map",
  "neighbour": "RegionShapeMap-module__-myYZW__neighbour",
  "region": "RegionShapeMap-module__-myYZW__region",
  "sibling": "RegionShapeMap-module__-myYZW__sibling",
});
